module.exports = __webpack_public_path__ + "img/logo.f123178e.png";